import { injectable } from "inversify";
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from "@xlearn/common";
import * as Api from "@/app/state-serialization/api";
import { ChoiceState } from "./choice-interfaces";
import { ProtobufSerializer } from "@/app/state-serialization/infrastructure";

@injectable()
export class ChoiceQuestionStateProtobufSerializer
  implements Api.StateSerializationPlugin<ChoiceState> {
  key = {
    id: 11,
    name: { ns: "suspend-data", name: "question-state-choice" },
    format: "protobuf"
  };

  serialize(data: ChoiceState): Result<Uint8Array, Api.SerializerError> {
    const message = new ChoiceStateProtoMessage({
      answersOrder: data.answersOrder,
    });

    return ProtobufSerializer.serialize<ChoiceStateProtoMessage>(
      message,
      ChoiceStateProtoMessage
    );
  }

  deserialize(content: Uint8Array): Result<ChoiceState, Api.DeserializerError> {
    const deserializeResult = ProtobufSerializer.deserialize<ChoiceStateProtoMessage>(content, ChoiceStateProtoMessage);
    if (!deserializeResult.success) {
      return deserializeResult;
    }

    const message = deserializeResult.value;
    const result: ChoiceState = {
      answersOrder: message.answersOrder,
    };

    return ok(result);
  }
}

@Type.d("ChoiceStateProtoMessage")
class ChoiceStateProtoMessage extends Message<ChoiceStateProtoMessage> {
  @Field.d(1, "string", "repeated")
  answersOrder: string[];
}
